export const fullscreenCameraOpen = (state) => state.appState.dock.cameraDock.cameraPriority.modalOpen;
